import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { EBetPositionErrorCode } from '../types';

export const LOAD_BET_POSITION_FAIL = 'BET_POSITION :: LOAD_BET_POSITION_FAIL';

export type TLoadBetPositionFailAction = IReduxAction<typeof LOAD_BET_POSITION_FAIL, EBetPositionErrorCode>;

export const loadBetPositionFail = actionGenerator<typeof LOAD_BET_POSITION_FAIL, EBetPositionErrorCode>(
  LOAD_BET_POSITION_FAIL,
);
